/* Trusted Shops consent signaller.
   Runs only after the Shopify cookie banner allows marketing.
   Trusted Shops must enable "Trustbadge Consent Request (manual)"
   (consentManagementType is OFF until then). */
(function () {
  var SIGNAL_ID = 'goelles-ts-consent-signal';

  function signalElement() {
    return document.getElementById(SIGNAL_ID);
  }

  function reevaluate() {
    if (window.trustbadge && typeof window.trustbadge.reevaluateConsent === 'function') {
      window.trustbadge.reevaluateConsent();
    }
  }

  function clearSignal() {
    var existing = signalElement();
    if (!existing) return;
    existing.remove();
    if (window.trustbadge) {
      delete window.trustbadge.consentSignallerScript;
    }
    reevaluate();
  }

  function setSignal() {
    if (signalElement()) {
      reevaluate();
      return;
    }
    var script = document.createElement('script');
    script.id = SIGNAL_ID;
    script.textContent = [
      'var currentScript = document.currentScript;',
      'window.trustbadge = window.trustbadge',
      '  ? Object.assign({}, window.trustbadge, { consentSignallerScript: currentScript })',
      '  : { consentSignallerScript: currentScript };',
      'if (window.trustbadge.reevaluateConsent) window.trustbadge.reevaluateConsent();',
    ].join('\n');
    document.documentElement.appendChild(script);

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (!signalElement()) {
        window.clearInterval(timer);
        return;
      }
      if (window.trustbadge && typeof window.trustbadge.reevaluateConsent === 'function') {
        window.trustbadge.reevaluateConsent();
        window.clearInterval(timer);
      } else if (tries > 20) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  function apply(allowed) {
    if (allowed) setSignal();
    else clearSignal();
  }

  function readApi() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.marketingAllowed !== 'function') return;
    apply(api.marketingAllowed() === true);
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event && event.detail;
    if (detail && typeof detail.marketingAllowed === 'boolean') {
      apply(detail.marketingAllowed);
      return;
    }
    readApi();
  });

  function loadApi() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () {
        readApi();
      }
    );
  }

  if (window.Shopify && window.Shopify.loadFeatures) loadApi();
  else document.addEventListener('DOMContentLoaded', loadApi);
})();
